export enum MixerConstraintOption {
  NONE = 'none',
  BLEND_RATIO = 'blendRatio',
}

export enum MixerBlendRecipeOption {
  EXACT = 'exact',
  RANGE = 'range',
}
